<template>
  <div class="wrap">
    <div class="tech">
      <img :src="banner" alt="">
    </div>

    <div class="demo">
      <ul class="list">
        <li v-for="item in dataList" @click="skip(item)">
          <div class="left">
            <img v-if="item.middlePicture || item.organizerLogo"
                 :src="item.middlePicture">
            <p v-if="item.status == '直播中'"><img src="./../../../static/img/livving.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '直播'"><img src="./../../../static/img/living.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '即将开始'"><img src="./../../../static/img/nostart.png" style="height: 15px" alt=""></p>
            <p v-if="item.subjectType == 'live'"><img src="./../../../static/img/living.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '已结束'"><img src="./../../../static/img/livend.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '结束'"><img src="./../../../static/img/livend.png" style="height: 15px" alt=""></p>
            <p v-if="item.status == '视频回放'"><img src="./../../../static/img/replay.png" style="height: 15px;" alt=""></p>
            <p v-if="item.status == '回放'"><img src="./../../../static/img/replay.png" style="height: 15px" alt=""></p>
            <div v-if="item.play" class="Play"><img src="./../../../static/img/watch.png" alt=""></div>
          </div>
          <div class="right">
            <h3 class="title != null">{{item.title}}</h3>
            <p class="name" v-if="item.teacher != null">{{ item.teacher }}</p>
            <p class="name" v-if="item.teacherArr != null">大　咖：{{ item.teacherArr.truename }} {{ item.teacherArr.title }}</p>
            <p class="liveTime">{{ item.liveTime }}</p>
          </div>
        </li>


      </ul>
    </div>
    <returnPre></returnPre>
  </div>
</template>

<script>
  import api from 'api'
  export default {
    name: "technicaltopic",
    data () {
      return {
        banner:'',
        techurl:'',
        dataList: [],
        axiosUrl: '', // 发送请求的地址
        uid: '',
        pageNum: 0
      }
    },
    created () {
      const that = this
      var aid = this.$route.query.aid
      this.techurl = 'oldapi/mobile/subject/'+ aid + '?page=' + this.pageNum
      this.$axios.get(that.techurl).then(res => {
        that.banner = 'http://static.itdks.com' + res.data.data.img
        that.dataList = res.data.data.courseList
        if (that.dataList.length > 0) {
          that.dataList.forEach(item =>{
            item.middlePicture = 'http://static.itdks.com' + item.middlePicture
          })
        }
      })
    },
    mounted() {
      this.initData()
    },
    methods: {
      // 初始化
      async initData() {
        const params = {
          targetType: 'subject',
          targetId: this.$route.query.aid
        }
        const res = await api.common.getShareData(params)
        if (res.code === 0) {
          this.getShareInfo(true, res.data.shareTitle, res.data.shareDesc, res.data.shareImg)
        } else {
          this.getShareInfo()
        }
      },
      // 跳转
      skip(item) {
        if (item.type == 'live') {
          window.location.href = 'https://www.itdks.com/Home/Mobile/detail?type=bjy&id=' + item.id
        } else {
          window.location.href = 'https://www.itdks.com/Home/Mobile/detail?type=normal&id=' + item.id
        }
      }
    }
  }
</script>

<style scoped lang="less" scoped>
  .wrap{
    position: relative;
    overflow-y: hidden;
    .tech{

      width: 100%;
      height: 400px;
      display: flex;
      justify-content: center;

      img{
        position: relative;
        margin: 0;
        width: 100%;
        height: inherit;
        text-align: center;

      }
    }
    .techscroll{

    }}
  * {
    margin: 0;
    padding: 0;
    outline: none;
  }
  h3{
    margin-top: -8px;
  }
  .demo {
    margin-bottom: 92px;
  }

  .demo .list li {
    /* width: 750px; */
    height: 219px;
    padding: 25px 28px;
    box-sizing: border-box;
    border-bottom: 1px solid #dedede; /*no*/
    list-style: none;
    .left {
      width: 270px;
      height: 169px;
      line-height: 169px;
      margin-right: 10px;
      float: left;
      border-radius: 10px;
      overflow: hidden;
      position: relative;
      display: flex;
      > img {
        width: 270px;
        height: 169px;
      }
      .Play {
        position: absolute;
        width: 50px;
        height: 50px;
        right: 5px;
        bottom: 55px;
        z-index: 10;
        img {
          width: 50px;
          height: 50px;
        }
      }
      p {
        position: absolute;
        line-height: 30px;
        left: -10px;
        color: #fff;
        top: -2px;
        font-size: 18px; /*px*/
        padding: 2px 10px;
      }
      .living {
      }
      .begin {

      }
      .agin {
      }
      .end {
      }
    }
    .right {
      width: 390px;
      margin-left: 20px;
      float: right;
      font-size: 24px; /*px*/
      .title {
        font-size: 28px; /*px*/
        // line-height: 56px;
        font-weight: 500;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .name {
        color: #f2845a;
        margin-top: 30px;
        margin-bottom: 6px;
        height: 32px;
        background: url(../../assets/img/title_ico1.png) no-repeat left center;
        padding-left: 28px;
        background-size: 26px 26px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap
      }
      .organizer {
        color: #f3855d;
        height: 36px;
        margin-top: 12px;
        background: url(../../assets/img/title_ico1.png) no-repeat left center;
        padding-left: 28px;
        background-size: 26px 26px;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap
      }
      .liveTime,
      .hitNum {
        font-size: 24px !important;
        color: #8c8c8c;
        span {
          float: right;
        }
      }
      .liveTime,.livetime{
        background: url(./../../assets/img/time_ico.png) no-repeat left center;
        padding-left: 28px;
        background-size: 26px 26px;
      }
      .hitNum {
        margin-top: 14px;
        span {
          color: #fe0200;
          font-weight: 700;
        }
      }
      .livetime {
        color: #8c8c8c;
        span {
          float: right;
        }
      }
      .pptNum{
        position: absolute;
        width: 30px;
        height: 30px;
        right: 20px;
        background: url(./../../assets/img/ppt_ico.png) no-repeat left top;
        padding-left: 30px;
        background-size: 26px 26px;
        margin-top: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage-Children/OldSubject.vue